import React from "react"

interface Props {
  size: number
}
const shareAnimatednIconHref = "https://res.cloudinary.com/perkbox/image/upload/v1717529853/a7409c8c-84d1-48f3-835c-d2e7610a7e3b.gif"
const ShareAnimated = (props: Props) => {
  const {size} = props
  return <img src={shareAnimatednIconHref} width={size} height={size} {...props} />
}

export default ShareAnimated
